export const GOOGLE_MAPS_URL = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places`;
export const PIN_PAYMENTS_PUBLISHABLE_API_KEY =
  process.env.REACT_APP_PIN_PAYMENTS_PUBLISHABLE_API_KEY;
export const PIN_PAYMENTS_URL = process.env.REACT_APP_PIN_PAYMENTS_URL;
export const CUSTOMER_MICROSERVICE_UNAUTH_BASE_URL = process.env.REACT_APP_CUSTOMER_MICROSERVICE_UNAUTH_BASE_URL;
export const TERMS_AND_CONDITIONS_URL =
  process.env.REACT_APP_TERMS_AND_CONDITIONS_URL;
